export default {
  // Table column headers
  counterparty: "Counterparty",
  inflowAmount: "Inflow Amount (USDT)",
  inflowCount: "Inflow Count (USDT)",
  outflowAmount: "Outflow Amount (USDT)",
  outflowCount: "Outflow Count (USDT)",

  // Loading and status
  loading: "Loading...",
  noData: "No data",

  // Download
  downloadDetails: "Download Details",
  downloadNote: "Note: Maximum 100,000 records can be downloaded",

  // Message prompts
  copySuccess: "Copy successful!",
};
